import React from "react";
import { useAppSelector } from "../../../../store";
import { formatCurrency } from "../../../../utils/formatting";
import { selectors } from "../../../../store/selectors";

export const DriveSummary: React.FC = () => {
  const {
    totalCost,
    maneuverDriveCost,
    jumpDriveCost,
    reactionDriveCost,
    totalConsumedVolume,
    maneuverDriveVolume,
    jumpDriveVolume,
    reactionDriveVolume,
  } = useAppSelector((state) => state.shipBuilder.driveStats) || {};

  const shipSize = useAppSelector((state) => state.shipBuilder.shipSize);
  // Use selector for total drive power
  const totalDrivePower = useAppSelector(
    selectors.derived.selectTotalDrivePower,
  );

  return (
    <div className="bg-gray-800 text-white p-4 shadow-lg">
      <div className="container mx-auto grid grid-cols-[1fr_auto_auto] grid-rows-2 gap-x-12 items-center">
        {/* Row 1: Cost Breakdown */}
        <div className="flex items-center gap-6 text-sm">
          <div>
            <span className="text-gray-400 block">Maneuver Drive</span>
            <span className="font-semibold">
              {formatCurrency(maneuverDriveCost || 0)}
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Jump Drive</span>
            <span className="font-semibold">
              {formatCurrency(jumpDriveCost || 0)}
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Reaction Drive</span>
            <span className="font-semibold">
              {formatCurrency(reactionDriveCost || 0)}
            </span>
          </div>
        </div>
        <div className="text-right">
          <span className="text-gray-400 block text-sm">Total Drive Cost</span>
          <span className="text-xl font-bold text-green-400">
            {formatCurrency(totalCost || 0)}
          </span>
        </div>

        {/* Drive Power - Spanning both rows */}
        <div className="row-span-2 flex flex-col items-center justify-center border-l border-r border-gray-700 px-8">
          <span className="text-gray-400 block text-sm">Drive Power</span>
          <span className="text-3xl font-bold text-yellow-400">
            {((totalDrivePower as number) || 0).toFixed(0)} Power
          </span>
        </div>

        {/* Row 2: Volume Breakdown */}
        <div className="flex items-center gap-6 text-sm border-t border-gray-700 pt-2 mt-2 col-span-1">
          <div>
            <span className="text-gray-400 block">Maneuver Drive</span>
            <span className="font-semibold">
              {(maneuverDriveVolume || 0).toFixed(1)} tons
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Jump Drive</span>
            <span className="font-semibold">
              {(jumpDriveVolume || 0).toFixed(1)} tons
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Reaction Drive</span>
            <span className="font-semibold">
              {(reactionDriveVolume || 0).toFixed(1)} tons
            </span>
          </div>
        </div>
        <div className="text-right border-t border-gray-700 pt-2 mt-2">
          <span className="text-gray-400 block text-sm">
            Total Consumed Volume
          </span>
          <span className="text-xl font-bold text-blue-400">
            {(totalConsumedVolume || 0).toFixed(1)} tons
          </span>
        </div>
      </div>
    </div>
  );
};
